import { ToggleGroup } from '@nesso/ui/primitives/toggle-group';

import type { SessionNoteSettings, SessionNoteType } from '@/entities/session-note';

import {
    SETTING_DEFS,
    SETTINGS_BY_NOTE_TYPE,
} from '../../config/edit-session-note-settings.config';
import type { EditableNoteSettingKey } from '../../model/edit-session-note-settings.types';
import { EditSessionNoteSettingsToggleItem } from './edit-session-note-settings-content/edit-session-note-settings-toggle-item';

type Props = {
    type: SessionNoteType;
    settings: SessionNoteSettings;
    onChange: <T extends EditableNoteSettingKey>(key: T, value: SessionNoteSettings[T]) => void;
};

export function EditSessionNoteSettingsContent({ type, settings, onChange }: Props) {
    const visibleKeys = SETTINGS_BY_NOTE_TYPE[type];

    return (
        <div className="flex flex-col flex-1 px-6 pb-8 space-y-8 border-b overflow-y-auto">
            {visibleKeys.map((key) => {
                const def = SETTING_DEFS[key];
                return (
                    <div key={key} className="flex flex-col gap-2">
                        <span className="font-semibold text-sm">{def.label}</span>
                        <ToggleGroup
                            type="single"
                            size={def.size}
                            value={settings[key]}
                            onValueChange={(value) =>
                                value && onChange(key, value as SessionNoteSettings[typeof key])
                            }
                            className="w-full justify-between gap-2"
                        >
                            {def.options.map((option) => (
                                <EditSessionNoteSettingsToggleItem
                                    key={option.value}
                                    value={option.value}
                                >
                                    {option.label}
                                </EditSessionNoteSettingsToggleItem>
                            ))}
                        </ToggleGroup>
                    </div>
                );
            })}
        </div>
    );
}
